import type { SnackBarConfig } from '@shared/components/Snackbar';
import { LockOutlined } from '@mui/icons-material';
import Button from '@shared/components/Buttons/Button';
import CustomSnackbar from '@shared/components/Snackbar';
import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '@/shared/components/Input';
import { UserPoolData } from '../types/types.auth';

function ForgotPassword() {
  const [snackbarConfig, setSnackbarConfig] = useState<SnackBarConfig>();
  const [userEmail, setUserEmail] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const navigate = useNavigate();

  const handleSnackBarClose = () => {
    if (!snackbarConfig) return;
    setSnackbarConfig({ ...snackbarConfig, open: false });
  };

  const user = new CognitoUser({
    Username: userEmail,
    Pool: new CognitoUserPool(UserPoolData),
  });

  const handleEmailSubmit = () => {
    user.forgotPassword({
      onSuccess: () => {
        setEmailSent(true);
      },
      onFailure: () => {},
    });
  };

  const confirmPasswordChange = () => {
    return new Promise(() => {
      user.confirmPassword(verificationCode, newPassword, {
        onFailure() {},
        onSuccess() {
          navigate('/sign-in');
        },
      });
    });
  };

  return (
    <div className="auth-page__form-panel">
      <div className="auth-page__form-wrapper">
        <div className="auth-form">
          <div className="form-header">
            <span className="forgot-password__icon-wrapper">
              <LockOutlined />
            </span>
            <h1 className="form-title">Reset password</h1>
            <p className="form-subtitle">
              {!emailSent
                ? "Enter the email you signed up with — we'll send you a verification code."
                : 'Enter the code we sent you, then choose a new password.'}
            </p>
          </div>

          {!emailSent ? (
            <form
              className="form"
              onSubmit={(e) => {
                e.preventDefault();
                handleEmailSubmit();
              }}
            >
              <div className="field">
                <label htmlFor="forgot-email" className="label">
                  Email
                </label>
                <Input
                  type="email"
                  name="forgot-email"
                  currentValue={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  fullWidth
                />
              </div>
              <div className="mt-16">
                <Button type="submit" fullWidth disabled={!userEmail}>
                  Send verification email
                </Button>
              </div>
            </form>
          ) : (
            <form
              className="form"
              onSubmit={(e) => {
                e.preventDefault();
                confirmPasswordChange();
              }}
            >
              <div className="field">
                <label htmlFor="verification-code" className="label">
                  Verification code
                </label>
                <Input
                  type="text"
                  name="verification-code"
                  currentValue={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  fullWidth
                />
              </div>
              <div className="field">
                <label htmlFor="new-password" className="label">
                  New password
                </label>
                <Input
                  type="password"
                  name="new-password"
                  currentValue={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  fullWidth
                />
              </div>
              <div className="mt-16">
                <Button type="submit" fullWidth disabled={!verificationCode || !newPassword}>
                  Reset password
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
      <CustomSnackbar config={snackbarConfig} setOpen={handleSnackBarClose} />
    </div>
  );
}

export default ForgotPassword;
